export default {
  getRetencao(state) {
    return state.retencao
  }
}
